import { render, staticRenderFns } from "./PsFooter.vue?vue&type=template&id=63134086&"
import script from "./PsFooter.vue?vue&type=script&lang=js&"
export * from "./PsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports